import { InboxOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import styled from "styled-components";

const { Text } = Typography;

interface SharedEmptyProps {
  description: string;
}

/**
 * EMPTY STATE — Centered icon + description for zero-content views.
 *
 * Design decisions:
 * - Large circular icon container draws attention to the state
 * - Primary-light background matches our brand subtly
 * - Generous padding (48px) gives breathing room
 * - Description text uses secondary color — informative, not alarming
 *
 * Illustration placeholder: search "empty inbox" or "no results"
 * on Storyset (storyset.com) for a human illustration replacement.
 */
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-12) var(--space-4);
`;

const IconCircle = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: var(--color-primary-light);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--space-4);
  font-size: 30px;
  color: var(--color-primary);
`;

const Description = styled(Text)`
  &.ant-typography {
    font-size: var(--text-sm);
    color: var(--color-text-secondary);
    font-weight: var(--weight-medium);
    text-align: center;
    max-width: 280px;
    line-height: var(--leading-normal);
  }
`;

const SharedEmpty: React.FC<SharedEmptyProps> = ({ description }) => (
  <Wrapper>
    <IconCircle>
      <InboxOutlined />
    </IconCircle>
    <Description>{description}</Description>
  </Wrapper>
);

export { SharedEmpty };
